import * as React from 'react';
import { useLocation } from 'react-router-dom';
import { useAuth } from 'hooks/auth';
import { usePermission } from 'hooks/usePermission';
import { cn } from 'lib/utils';
import { SCHEDULED_REPORTS_ROUTES } from 'lib/routes';

import * as S from './styles';

type Route = {
  title: string;
  path: string;
  blockedRoles?: string[];
  permissions?: string[];
};

const ROUTES: Route[] = [
  {
    title: 'Tracking de notas fiscais',
    path: SCHEDULED_REPORTS_ROUTES.invoicesTracking().url,
  },
  {
    title: 'Tracking por viagem',
    path: SCHEDULED_REPORTS_ROUTES.tripsTracking().url,
  },
  {
    title: 'Relatório de inventário',
    path: SCHEDULED_REPORTS_ROUTES.inventoryDailyItemsIntegral().url,
  },
  {
    title: 'Viagens a faturar',
    path: SCHEDULED_REPORTS_ROUTES.viagensBilling().url,
    permissions: SCHEDULED_REPORTS_ROUTES.viagensBilling().permissions,
  },
];

export const TabbedNavigation = ({
                                   className,
                                   ...props
                                 }: React.HTMLAttributes<HTMLDivElement>) => {
  const location = useLocation();
  const { profile } = useAuth();
  const { hasPermissionTo } = usePermission();

  const isRouteAllowed = React.useCallback(
    (route: Route) => {
      if (route.blockedRoles?.includes(profile?.type || '')) return false;
      if (route.permissions?.length) return hasPermissionTo(route.permissions);
      return true;
    },
    [profile?.type, hasPermissionTo],
  );

  const isRouteActive = React.useCallback(
    (path: string) => {
      if (path.includes('#')) {
        const [pathname, hash] = path.split('#');
        return location.pathname === pathname && location.hash === `#${hash}`;
      }

      return location.pathname === path;
    },
    [location.pathname, location.hash],
  );

  return (
    <div {...props} className={cn('flex flex-col w-full mb-6', className)}>
      <S.Container>
        {ROUTES.map((route) => (
          isRouteAllowed(route) && (
            <S.Button
              key={route.path}
              to={route.path}
              className={isRouteActive(route.path) ? 'active' : ''}
            >
              {route.title}
            </S.Button>
          )
        ))}
      </S.Container>
    </div>
  );
};
